 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		51: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		51: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~StoryTemplateChunkstory-templates-__tests__-public-story-test~StoryTemplateChunkstory-templa~b2fbd8d4","1":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-listicle-~1c33e2aa","2":"vendors~StoryTemplateChunkstory-templates-__tests__-public-story-test~StoryTemplateChunkstory-templa~954a6e33","3":"vendors~StoryTemplateChunkstory-templates-__tests__-public-story-test~StoryTemplateChunkstory-templa~3f6a6365","4":"footer_1~footer_2~footer_3~header_1~header_2~header_3~header_4~single-layer-header_1~single-layer-he~2c9e60d9","5":"vendors~header_1~header_2~header_3~header_4~single-layer-header_1~single-layer-header_2~single-layer~2cb341c2","6":"vendors~StoryTemplateChunkstory-templates-__tests__-public-story-test~StoryTemplateChunkstory-templa~2b6dda25","7":"StoryTemplateChunkstory-templates-listicle-story","8":"StoryTemplateChunkstory-templates-listicle-story-new","9":"StoryTemplateChunkstory-templates-listicle-story-old","10":"StoryTemplateChunkstory-templates-live-blog","11":"StoryTemplateChunkstory-templates-live-blog-new","12":"StoryTemplateChunkstory-templates-live-blog-old","13":"StoryTemplateChunkstory-templates-photo-story","14":"StoryTemplateChunkstory-templates-photo-story-new","15":"StoryTemplateChunkstory-templates-photo-story-old","16":"StoryTemplateChunkstory-templates-snapshot","17":"StoryTemplateChunkstory-templates-text-story","18":"StoryTemplateChunkstory-templates-text-story-new","19":"StoryTemplateChunkstory-templates-text-story-old","20":"StoryTemplateChunkstory-templates-video-story","21":"StoryTemplateChunkstory-templates-video-story-new","22":"StoryTemplateChunkstory-templates-video-story-old","23":"StoryTemplateChunkstory-templates-visual-story","24":"vendors~StoryTemplateChunkstory-templates-visual-story","25":"StoryTemplateChunkstory-templates-__tests__-public-story-test","26":"StoryTemplateChunkstory-templates-__tests__-story-row-wrapper-test","27":"StoryTemplateChunkstory-templates-other","28":"StoryTemplateChunkstory-templates-paywall-story","29":"StoryTemplateChunkstory-templates-photo-story-old-story-selectors","30":"StoryTemplateChunkstory-templates-public-story","31":"StoryTemplateChunkstory-templates-story-row-wrapper","32":"StoryTemplateChunkstory-templates-story-selectors","33":"StoryTemplateChunkstory-templates-text-story-old-story-selectors","34":"StoryTemplateChunkstory-templates-video-story-old-story-selectors","35":"vendors~StoryTemplateChunkstory-templates-__tests__-story-row-wrapper-test","36":"vendors~firebase-app~firebase-messaging","37":"vendors~home~list","39":"SSOWrapperBase","40":"SidebarTemplate","41":"StoryTemplateChunkstory-templates-__tests__-__snapshots__-public-story-test-js-snap","42":"StoryTemplateChunkstory-templates-blank-m-css","43":"StoryTemplateChunkstory-templates-listicle-story-listicle-m-css","44":"StoryTemplateChunkstory-templates-listicle-story-old-listicle-m-css","45":"StoryTemplateChunkstory-templates-live-blog-old-live-blog-module-css","46":"StoryTemplateChunkstory-templates-photo-story-old-photo-module-css","47":"StoryTemplateChunkstory-templates-snapshot-snapshot-m-css","48":"StoryTemplateChunkstory-templates-text-story-old-text-story-m-css","49":"StoryTemplateChunkstory-templates-video-story-old-video-m-css","50":"StoryTemplateChunkstory-templates-visual-story-visual-story-m-css","52":"firebase-app","54":"footer_1","55":"footer_2","56":"footer_3","57":"glide","58":"header_1","59":"header_2","60":"header_3","61":"header_4","62":"home","63":"list","64":"metypeFeedWidget","66":"qtc-parsecsv","67":"secret-mode","69":"single-layer-header_1","70":"single-layer-header_2","71":"single-layer-header_3","72":"single-layer-header_4","73":"single-layer-header_5","74":"story","75":"subscription","76":"vendors~firebase-messaging","77":"vendors~qtc-react-youtube","78":"vendors~secret-mode"}[chunkId]||chunkId) + "-" + "44db82d266a8821f41f6" + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"3":1,"4":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"25":1,"26":1,"27":1,"28":1,"30":1,"31":1,"37":1,"39":1,"40":1,"42":1,"43":1,"44":1,"45":1,"46":1,"47":1,"48":1,"49":1,"50":1,"54":1,"55":1,"56":1,"57":1,"58":1,"59":1,"60":1,"61":1,"62":1,"63":1,"67":1,"69":1,"70":1,"71":1,"72":1,"73":1,"74":1,"75":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"vendors~StoryTemplateChunkstory-templates-__tests__-public-story-test~StoryTemplateChunkstory-templa~b2fbd8d4","1":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-listicle-~1c33e2aa","2":"vendors~StoryTemplateChunkstory-templates-__tests__-public-story-test~StoryTemplateChunkstory-templa~954a6e33","3":"vendors~StoryTemplateChunkstory-templates-__tests__-public-story-test~StoryTemplateChunkstory-templa~3f6a6365","4":"footer_1~footer_2~footer_3~header_1~header_2~header_3~header_4~single-layer-header_1~single-layer-he~2c9e60d9","5":"vendors~header_1~header_2~header_3~header_4~single-layer-header_1~single-layer-header_2~single-layer~2cb341c2","6":"vendors~StoryTemplateChunkstory-templates-__tests__-public-story-test~StoryTemplateChunkstory-templa~2b6dda25","7":"StoryTemplateChunkstory-templates-listicle-story","8":"StoryTemplateChunkstory-templates-listicle-story-new","9":"StoryTemplateChunkstory-templates-listicle-story-old","10":"StoryTemplateChunkstory-templates-live-blog","11":"StoryTemplateChunkstory-templates-live-blog-new","12":"StoryTemplateChunkstory-templates-live-blog-old","13":"StoryTemplateChunkstory-templates-photo-story","14":"StoryTemplateChunkstory-templates-photo-story-new","15":"StoryTemplateChunkstory-templates-photo-story-old","16":"StoryTemplateChunkstory-templates-snapshot","17":"StoryTemplateChunkstory-templates-text-story","18":"StoryTemplateChunkstory-templates-text-story-new","19":"StoryTemplateChunkstory-templates-text-story-old","20":"StoryTemplateChunkstory-templates-video-story","21":"StoryTemplateChunkstory-templates-video-story-new","22":"StoryTemplateChunkstory-templates-video-story-old","23":"StoryTemplateChunkstory-templates-visual-story","24":"vendors~StoryTemplateChunkstory-templates-visual-story","25":"StoryTemplateChunkstory-templates-__tests__-public-story-test","26":"StoryTemplateChunkstory-templates-__tests__-story-row-wrapper-test","27":"StoryTemplateChunkstory-templates-other","28":"StoryTemplateChunkstory-templates-paywall-story","29":"StoryTemplateChunkstory-templates-photo-story-old-story-selectors","30":"StoryTemplateChunkstory-templates-public-story","31":"StoryTemplateChunkstory-templates-story-row-wrapper","32":"StoryTemplateChunkstory-templates-story-selectors","33":"StoryTemplateChunkstory-templates-text-story-old-story-selectors","34":"StoryTemplateChunkstory-templates-video-story-old-story-selectors","35":"vendors~StoryTemplateChunkstory-templates-__tests__-story-row-wrapper-test","36":"vendors~firebase-app~firebase-messaging","37":"vendors~home~list","39":"SSOWrapperBase","40":"SidebarTemplate","41":"StoryTemplateChunkstory-templates-__tests__-__snapshots__-public-story-test-js-snap","42":"StoryTemplateChunkstory-templates-blank-m-css","43":"StoryTemplateChunkstory-templates-listicle-story-listicle-m-css","44":"StoryTemplateChunkstory-templates-listicle-story-old-listicle-m-css","45":"StoryTemplateChunkstory-templates-live-blog-old-live-blog-module-css","46":"StoryTemplateChunkstory-templates-photo-story-old-photo-module-css","47":"StoryTemplateChunkstory-templates-snapshot-snapshot-m-css","48":"StoryTemplateChunkstory-templates-text-story-old-text-story-m-css","49":"StoryTemplateChunkstory-templates-video-story-old-video-m-css","50":"StoryTemplateChunkstory-templates-visual-story-visual-story-m-css","52":"firebase-app","54":"footer_1","55":"footer_2","56":"footer_3","57":"glide","58":"header_1","59":"header_2","60":"header_3","61":"header_4","62":"home","63":"list","64":"metypeFeedWidget","66":"qtc-parsecsv","67":"secret-mode","69":"single-layer-header_1","70":"single-layer-header_2","71":"single-layer-header_3","72":"single-layer-header_4","73":"single-layer-header_5","74":"story","75":"subscription","76":"vendors~firebase-messaging","77":"vendors~qtc-react-youtube","78":"vendors~secret-mode"}[chunkId]||chunkId) + "-" + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"c3df0332bf9c534f4de5","4":"213da90d52914217d432","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"623eeb695d352729d62f","8":"baf5ddf0cb19df7fac1f","9":"ece5da540d192a68e2f0","10":"b01963df58c28c5b5cba","11":"baf5ddf0cb19df7fac1f","12":"9f2bfc03ceb5a168662c","13":"47e41d108566a25e2fd3","14":"baf5ddf0cb19df7fac1f","15":"ff653c5146ef0dc49bd1","16":"dcfe524663e7057bcd50","17":"0a14f08a7e0be3efbeee","18":"baf5ddf0cb19df7fac1f","19":"f115981b881be67fdf70","20":"bc0612365d78ad0cbef0","21":"baf5ddf0cb19df7fac1f","22":"2a5fea256a5883b971a9","23":"8fc1345e6a4c8676e91e","24":"31d6cfe0d16ae931b73c","25":"1c7888dae68ba0c536b4","26":"caa0a1a44b68c63b8cf9","27":"0f7fa01483e98e79b769","28":"527116fa3f8d1a13f854","29":"31d6cfe0d16ae931b73c","30":"1c7888dae68ba0c536b4","31":"caa0a1a44b68c63b8cf9","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"acf8c787e76c83154ad1","38":"31d6cfe0d16ae931b73c","39":"a751517e4328b0ad33d7","40":"3a48db6f0391e03de3a4","41":"31d6cfe0d16ae931b73c","42":"775be5d7b6c5f5605d5f","43":"53849cc3faa0f7c41546","44":"5026be7e629e76b7e0a6","45":"f59e9aa1038f513be4f5","46":"b38bff7c081fe54aa0d0","47":"37f4c29b668fa75809f1","48":"dd7d98713ae1ddef4bf2","49":"9aa9bdde99cbef6edd54","50":"1a35dbe55fc5adce6eec","52":"31d6cfe0d16ae931b73c","54":"8e2ac9f97b5b41d27941","55":"beb7efde753797a08ff7","56":"7ca80661d31bb2a8c7c2","57":"5601a62b777eb193927d","58":"fe61b359479d7e356a97","59":"cc3072fac782b4cb3708","60":"c3e35fc7b382b778af01","61":"96db8a04e80e62f2fdbd","62":"1b122d3c47bcaae99b0d","63":"808865428e0a2196f8f6","64":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"499d1826a1fbbe7088dc","69":"56a301bef26be30b92d9","70":"22fd139b0e9b63aaee86","71":"00161dd24339d68dfcb9","72":"8ef33fbaeedf3956d6f5","73":"8ae35b8ade9ce5c59bd7","74":"a7526dddc97dfdc0e56b","75":"000dfa8175a7616f19d7","76":"31d6cfe0d16ae931b73c","77":"31d6cfe0d16ae931b73c","78":"31d6cfe0d16ae931b73c","79":"31d6cfe0d16ae931b73c","80":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}

 		// chunk preloadng for javascript

 		var chunkPreloadMap = {
 			"74": [
 				0,
 				2,
 				3,
 				6,
 				25,
 				30,
 				1,
 				7,
 				8,
 				9,
 				10,
 				11,
 				12,
 				27,
 				28,
 				13,
 				14,
 				15,
 				17,
 				18,
 				19,
 				20,
 				21,
 				22,
 				35,
 				26,
 				31,
 				24,
 				23,
 				41,
 				42,
 				43,
 				44,
 				45,
 				46,
 				29,
 				32,
 				33,
 				48,
 				34,
 				49,
 				50
 			]
 		};

 		var chunkPreloadData = chunkPreloadMap[chunkId];
 		if(chunkPreloadData) {
 			chunkPreloadData.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					link.charset = 'utf-8';
 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "preload";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/quintype-ace/assets/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 202);
